export enum TransportBufferType {
  Arrival = 'arrival',
  Departure = 'departure',
  Load = 'load',
  Safety = 'safety',
  DriverOnSpot = 'driver_on_spot',
  Waiting = 'waiting',
}